// Разбор ответа на запрос подписи — общий для обоих диалогов ЭЦП (DigitalSignDialog —
// документы заявки, AgreementSignDialog — пользовательское соглашение).
//
// Обёртки http.post/http.get (api/https.ts) ошибку НЕ бросают, а возвращают AxiosError объектом,
// поэтому тело ответа лежит в response.response.data. Для отказов с {message, code} interceptor
// уже открыл диалог с причиной от CDS («Неверный ПИН-код! Осталось попыток: 2») — второе
// сообщение показывать не нужно.

/** Ответ сервера об отказе: contract — CdsResultMapper на бэкенде. */
export interface SignFailure {
  message?: string;
  code?: string;
}

/** Тело отказа, если сервер его прислал; иначе undefined (сеть, таймаут, пустой 500). */
export const getSignFailure = (response: any): SignFailure | undefined => {
  const data = response?.response?.data ?? response?.data;
  return data && typeof data === "object" && data.code ? (data as SignFailure) : undefined;
};

/** Успешный ответ (200/201). */
export const isSignSuccess = (response: any): boolean =>
  response?.status === 200 || response?.status === 201;
